import { useEffect } from 'react';

export const SECOND_CONTROLS = {
  ctrl: 'ctrl'
};
const CONTROL_CONDITION = {
  [SECOND_CONTROLS.ctrl]: e => e.metaKey || e.ctrlKey
};
const DEFAULT_FUNC = () => true;

export const useKeyboardSubmission = ({
  handleSubmit,
  key = 'Enter',
  secondKey = ''
}) => {
  useEffect(() => {
    if (handleSubmit) {
      const submitShortcut = e => {
        const secondCondition = CONTROL_CONDITION[secondKey] || DEFAULT_FUNC;
        if (e.key === key && secondCondition(e)) {
          handleSubmit();
        }
      };

      document.addEventListener('keydown', submitShortcut);

      return () => {
        document.removeEventListener('keydown', submitShortcut);
      };
    }
  }, [handleSubmit, key, secondKey]);
};
